import { useCallback } from "react";

import FlashContext from "components/FlashMessages/FlashContext";
import { createDefaultMutationHook } from "hooks/useMutationHandler";
import useTypedContext from "hooks/useTypedContext";

import { DELETE_SPACELIFT_VCS_REPO } from "./gql";
import { SEARCH_SPACELIFT_VCS_REPOS } from "../useSpaceliftVcsReposList/gql";

const useDeleteSpaceliftVcsRepoMutation = createDefaultMutationHook(DELETE_SPACELIFT_VCS_REPO);

const useDeleteSpaceliftVcsRepo = () => {
  const { reportSuccess } = useTypedContext(FlashContext);

  const [mutation, { loading }] = useDeleteSpaceliftVcsRepoMutation({
    refetchQueries: [SEARCH_SPACELIFT_VCS_REPOS],
  });

  const deleteSpaceliftVcsRepo = useCallback(
    (id: string, onSuccess?: () => void) => {
      mutation({ id }, (data) => {
        if (data?.repoDelete) {
          reportSuccess({ message: "Repo deleted successfully" });
          onSuccess?.();
        }
      });
    },
    [mutation, reportSuccess]
  );

  return {
    deleteSpaceliftVcsRepo,
    loading,
  };
};

export default useDeleteSpaceliftVcsRepo;
